import styled, { css } from 'styled-components'

export const DefaultFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const FormItemTitle = styled.span`
  color: #353744;
  font-weight: 900;
  font-size: 24px;
  line-height: 34px;

  #last12months, #next12months {
    text-decoration: underline;
    text-shadow: 0.5px 0 #353744;
  }
`

export const FormItemSubtitle = styled.span`
  color: #52545D;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
`

export const FormRadioContainer = styled.div`
  width: 100%;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const FormContentContainer = styled.div<{ btnMaxWidth?: string }>`
  width: 100%;
  display: flex;
  margin-top: 24px;

  & .content {
    width: 100%;
    margin-left: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  & button {
    max-width: ${props => props.btnMaxWidth ?? '85%'};
    min-width: fit-content;
  }
`

export const AddressContentContainer = styled.div`
  width: 100%;
  display: flex;
  margin-top: 24px;

  & .address-form-content {
    display: flex;
    flex-direction: column;
    margin-left: 24px;
    gap: 24px;
    width: 100%;
  }

  & .address-form-inputs {
    width: 100%;
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 24px;

    @media only screen and (max-width: 640px) {
      display: flex;
      flex-direction: column;
    }
  }

  & button {
    width: fit-content;
  }
`

export const AddressOptions = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 24px;
`

interface FlexDivProps {
  dir?: 'column' | 'row';
  align?: string;
  justify?: string;
  maxWidth?: string;
  minWidth?: string;
  gap?: string;
  margin?: string;
  padding?: string;
  height?: string;
}

export const FlexDiv = styled.div<FlexDivProps>`
  width: 100%;
  max-width: ${props => props.maxWidth ?? '100%'};
  min-width: ${props => props.minWidth ?? 'unset'};
  height: ${props => props.height ?? '100%'};
  display: flex;
  flex-direction: ${props => props.dir ?? 'row'};
  align-items: ${props => props.align ?? 'flex-start'};
  justify-content: ${props => props.justify ?? 'flex-start'};
  gap: ${props => props.gap ?? '0'};
  margin: ${props => props.margin ?? '0'};
  padding: ${props => props.padding ?? '0'};
`

export const MapFormContainer = styled.div<{ marginTop?: string }>`
  width: 100%;
  height: 100%;

  & + & {
    margin-top: ${props => props.marginTop ?? '90px'};
  }
`

export const DateRangeContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 24px;
  margin: 24px 0 0 0;

  .date-range-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .date-range-inputs {
    margin-top: 12px;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
`

export const ContainerWithLeftBar = styled.div<{ maxWidth?: string, inputMaxWidth?: string }>`
  width: 100%;
  display: flex;
  margin-top: 24px;

  & .content {
    width: 100%;
    max-width: ${props => props.maxWidth ?? '100%'};
    display: flex;
    flex-direction: column;
    margin-left: 24px;
    gap: 24px;
  }

  & .file-picker-input {
    max-width: ${props => props.inputMaxWidth ?? '100%'};
  }
`

export const ClaimItemFormMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;

  & + & {
    margin-top: 100px;
  }
`

export const ClaimItemFormSection = styled.div<{ maxWidth?: string }>`
  width: 100%;
  max-width: ${props => props.maxWidth ?? '440px'};
  height: 100%;
  display: flex;
  gap: 12px;

  & > div {
    margin: 0;
  }
`

export const FormInputTitle = styled.h6<{sub?: boolean}>`
  font-weight: 900;
  font-size: 18px;
  line-height: 24px;
  color: #353744;

  ${props => props.sub && css`
    font-size: 14px;
    line-height: 21px;
  `}
`

export const ClaimItemFormSectionSubTitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #65666A;
`

export const ClaimItemTitle = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  h1 {
    font-family: 'Tiempos', sans-serif;
    font-weight: 800;
    font-size: 30px;
    line-height: 45px;
    color: #353744;
    margin: 32px 0 13px 0;
  }

  hr {
    border: 0.5px solid #C8C8C8;
  }
`

export const QuoteDetailBoxContainer = styled.div`
  width: 100%;
  padding: 32px 40px; 
  background: #FFFFFF;
  border: 2px solid #3D6666;

  h5 {
    font-weight: 900;
    font-size: 24px;
    line-height: 34px;
    color: #353744;
  }

  hr {
    border: 0.5px solid #EFEFEF;
    margin: 16px 0 24px;
  }

  p {
    margin-top: 24px;
    color: #65666A;
    font-size: 12px;
    line-height: 18px;
  }
`

export const QuoteDetailBoxContentDiv = styled.div`
  display: grid;
  grid-template-columns: 5fr 4fr;
  gap: 32px;

  @media only screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }

  div.quote-box-left {
    display: flex;
    flex-direction: column;
  }

  div.quote-box-right {
    width: 100%;
    height: fit-content;
    margin-top: 21px;
    border: 1px solid #C8C8C8;
    display: flex;
    flex-direction: column;
    padding: 17px 35px 32px;

    div.quote-box-icon {
      border-radius: 50%;
      height: 64px;
      width: 64px;
      background-color: #F5F9F9;
      display: flex;
      align-items: center;
      justify-content: center;  

      img {
        height: 25px;
        width: 25px;
      }
    }

    h6 {
      font-weight: 900;
      font-size: 16px;
      line-height: 24px;
      color: #937251;
      margin: 12px 0;
    }

    small {
      font-weight: 400;
      font-size: 10px;
      line-height: 18px;
      color: #52545D;
      margin-top: 8px;
    }
  }
`

export const Chip = styled.div`
  background: #F5F9F9;
  border: 1px solid #C8C8C8;
  border-radius: 32px;
  width: fit-content;
  font-weight: 800;
  font-size: 12px;
  line-height: 18px;
  color: #65666A;
  padding: 7px 12px;
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    fill: #3D6666;
  }

  & + & {
    margin-top: 9px;
  }
`

export const FormInputErrorMessage = styled.small`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #E84242;
`